{
  "login": "로그인",
  "logout": "로그아웃",
  "signOut": "로그아웃",
  "username": "사용자 이름",
  "password": "비밀번호",
  "forgotPassword": "비밀번호를 잊으셨나요?",
  "rememberMe": "로그인 유지",
  "loginButton": "로그인",
  "loginError": "사용자 이름 또는 비밀번호가 올바르지 않습니다",
  "sessionExpired": "세션이 만료되었습니다. 다시 로그인해 주세요.",
  "passwordChangedRelogin": "Your password was changed. Please sign in with your new password.",
  "signingIn": "로그인 중...",
  "loginSuccess": "로그인 성공",
  "showPassword": "비밀번호 표시",
  "hidePassword": "비밀번호 숨기기",
  "onboardingPrompt": "병원 또는 클리닉을 위해?",
  "onboardingCta": "도입 요청하기",
  "loginFailed": "로그인 실패",
  "seatCapReached": "이 라이선스의 사용자 한도에 도달했습니다. 관리자에게 문의하세요.",
  "mfaCodeLabel": "인증 코드",
  "mfaCodePrompt": "인증 앱의 6자리 코드를 입력하여 로그인을 완료하세요.",
  "mfaSetupRequired": "소속 기관에서 다단계 인증을 요구합니다. 계속하려면 인증 앱을 설정하세요.",
  "mfaCodePlaceholder": "6자리 코드",
  "mfaInvalidCode": "인증 코드가 올바르지 않습니다",
  "pages": {
    "userProfile": {
      "title": "내 프로필",
      "loading": "프로필을 불러오는 중...",
      "sections": {
        "profilePicture": "프로필 사진",
        "personalInformation": "개인 정보",
        "changePassword": "비밀번호 변경",
        "multiFactorAuth": "다단계 인증"
      },
      "fields": {
        "fullName": "이름",
        "email": "이메일",
        "phone": "전화번호",
        "currentPassword": "현재 비밀번호",
        "newPassword": "새 비밀번호",
        "confirmPassword": "새 비밀번호 확인",
        "required": "*"
      },
      "actions": {
        "saveChanges": "변경사항 저장",
        "changePassword": "비밀번호 변경",
        "setUpMfa": "다단계 인증 설정",
        "uploadAvatar": "업로드",
        "changeAvatar": "변경",
        "removeAvatar": "삭제",
        "verify": "확인"
      },
      "avatar": {
        "alt": "아바타",
        "helperText": "PNG, JPEG 또는 WebP 형식, 최대 4 MB. 업로드 전에 {{size}}×{{size}}로 조정됩니다."
      },
      "mfa": {
        "enabledMessage": "계정에 다단계 인증이 활성화되어 있습니다.",
        "intro": "다단계 인증을 활성화하여 계정의 보안을 강화하세요.",
        "scanInstruction": "인증 앱으로 이 URI를 스캔하거나 직접 복사하세요:",
        "copyUri": "URI 복사",
        "verificationCode": "인증 코드",
        "codePlaceholder": "6자리 코드 입력"
      },
      "validation": {
        "fullNameRequired": "이름을 입력해 주세요",
        "emailRequired": "유효한 이메일을 입력해 주세요",
        "currentPasswordRequired": "현재 비밀번호를 입력해 주세요",
        "newPasswordTooShort": "비밀번호는 8자 이상이어야 합니다",
        "confirmPasswordRequired": "비밀번호를 확인해 주세요",
        "passwordsMismatch": "비밀번호가 일치하지 않습니다"
      },
      "toasts": {
        "profileUpdated": "프로필이 업데이트되었습니다",
        "profileUpdateFailed": "프로필 업데이트에 실패했습니다",
        "passwordChanged": "비밀번호가 변경되었습니다",
        "passwordChangeFailed": "비밀번호 변경에 실패했습니다. 현재 비밀번호를 확인해 주세요.",
        "mfaSetupFailed": "다단계 인증 설정을 시작할 수 없습니다",
        "mfaEnabled": "다단계 인증이 활성화되었습니다",
        "mfaInvalidCode": "잘못된 인증 코드입니다",
        "avatarUpdated": "아바타가 업데이트되었습니다",
        "avatarUpdateFailed": "아바타 업데이트에 실패했습니다",
        "avatarRemoved": "아바타가 삭제되었습니다",
        "avatarRemoveFailed": "아바타 삭제에 실패했습니다",
        "imageTooLarge": "이미지는 4 MB 이하여야 합니다",
        "imageTooLargeServer": "이미지가 너무 큽니다. 더 작은 파일을 시도해 주세요",
        "copiedToClipboard": "클립보드에 복사되었습니다"
      }
    }
  },
  "components": {
    "sessionTimeoutWarning": {
      "critical": "세션이 1분 이내에 만료됩니다. 지금 작업을 저장하세요.",
      "expiringSoon_one": "세션이 {{count}}분 후에 만료됩니다.",
      "expiringSoon_other": "세션이 {{count}}분 후에 만료됩니다.",
      "extendButton": "세션 연장"
    }
  },
  "signInMethod": "Sign-in method",
  "signInPassword": "Password",
  "signInDirectory": "Directory",
  "signInSso": "SSO",
  "ldapDirectory": "Directory",
  "ldapLoading": "Loading directories…",
  "ldapEmpty": "No directories configured — contact your administrator.",
  "ssoEmail": "Work email",
  "ssoEmailPlaceholder": "you@hospital.org",
  "ssoContinue": "Continue with SSO",
  "ssoChecking": "Checking…",
  "ssoChoose": "Choose your sign-in provider",
  "ssoContinueWith": "Continue with {{name}}",
  "ssoNoneFound": "No SSO provider for this domain — try password or directory sign-in.",
  "ssoCallbackTitle": "Completing sign-in…",
  "ssoCallbackFailed": "Single sign-on failed",
  "ssoCallbackMissing": "Missing sign-in response — please try again.",
  "ssoBackToLogin": "Back to sign-in",
  "setup": {
    "title": "초기 설정",
    "subtitle": "이 설치의 첫 번째 관리자 계정을 만듭니다.",
    "username": "사용자 이름",
    "password": "비밀번호",
    "confirmPassword": "비밀번호 확인",
    "fullName": "성명(선택 사항)",
    "fullNamePlaceholder": "예: 김철수",
    "email": "이메일(선택 사항)",
    "submit": "관리자 계정 만들기",
    "submitting": "계정을 만드는 중…",
    "usernameHint": "3~64자: 소문자, 숫자, 점, 밑줄, 하이픈.",
    "passwordHint": "12자 이상, 대문자·소문자·숫자·특수문자를 포함해야 합니다.",
    "errUsername": "3~64자로 입력하세요: a–z, 0–9, 점, 밑줄, 하이픈.",
    "errPasswordLength": "비밀번호는 12자 이상이어야 합니다.",
    "errPasswordUpper": "비밀번호에 대문자를 포함하세요.",
    "errPasswordLower": "비밀번호에 소문자를 포함하세요.",
    "errPasswordDigit": "비밀번호에 숫자를 포함하세요.",
    "errPasswordSpecial": "비밀번호에 특수문자를 포함하세요.",
    "errConfirmRequired": "비밀번호를 다시 입력하세요.",
    "errConfirmMismatch": "비밀번호가 일치하지 않습니다.",
    "errFullName": "성명은 100자 이내로 입력하세요.",
    "errEmail": "유효한 이메일 주소를 입력하세요.",
    "successTitle": "관리자 계정을 만들었습니다",
    "successBody": "계정 “{{username}}”이(가) 준비되었습니다. 로그인하여 계속하세요.",
    "goToLogin": "로그인으로 이동",
    "claimedTitle": "설정이 이미 완료되었습니다",
    "claimedBody": "이 시스템에는 이미 관리자가 있습니다. 계정으로 로그인하세요.",
    "networkError": "서버에 연결할 수 없습니다. 연결을 확인하고 다시 시도하세요.",
    "retry": "다시 시도",
    "rateLimited": "시도 횟수가 너무 많습니다. 1분 후 다시 시도하세요.",
    "usernameTaken": "이미 사용 중인 사용자 이름입니다.",
    "submitFailed": "계정을 만들 수 없습니다. 다시 시도하세요."
  }
}
